<template>
  <div class="statistics">
    <div class="statistics-header">
      <el-date-picker
        v-model="searchForm.year"
        type="year"
        placeholder="选择年"
      />
      <el-date-picker
        v-model="searchForm.month"
        type="month"
        placeholder="选择月份"
      />
      <el-date-picker
        v-model="searchForm.day"
        type="date"
        placeholder="选择日期"
      />
    </div>
    <el-tabs
      v-model="searchForm.courseType"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="全部"
        name="all"
      >
        <tabContent
          v-if="searchForm.courseType === 'all'"
          :panel-data="result"
        />
      </el-tab-pane>
      <el-tab-pane
        label="直播课程"
        name="10"
      >
        <tabContent
          v-if="searchForm.courseType ==='10'"
          :panel-data="result"
        />
      </el-tab-pane>
      <el-tab-pane
        label="岗前课程"
        name="20"
      >
        <tabContent
          v-if="searchForm.courseType ==='20'"
          :panel-data="result"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axClient from '@/services';
import tabContent from './panel/index.vue';

export default {
  name: 'Home',
  components: {
    tabContent,
  },
  data() {
    return {
      searchForm: {
        year: null,
        month: null,
        day: null,
        courseType: 'all',
      },
      result: {
        agencyTopCountList: [], agencyTopAmountList: [], payAmountList: [],
      },
    };
  },
  watch: {
    searchForm: {
      handler() {
        this.getHomePageStatistics();
      },
      deep: true,
    },
  },
  mounted() {
    this.getHomePageStatistics();
  },
  created() {
    this.initTime();
  },
  methods: {
    // 获取列表
    async getHomePageStatistics() {
      const body = {
        courseType: this.searchForm.courseType === 'all' ? null : Number(this.searchForm.courseType),
        day: this.$time(this.searchForm.day).date(),
        month: this.searchForm.month ? this.$time(this.searchForm.month).month() + 1 : null,
        year: this.searchForm.year ? this.$time(this.searchForm.year).year() : this.$time().year(),
      };
      const result = await axClient.statistics.getHomePageStatistics(body);
      this.result = result;
      // 处理折线图数据
      if (this.result.payAmountList.length > 0) {
        const arr = [];
        this.result.payAmountList.forEach((item) => {
          arr.push({
            periodStr: item.periodStr,
            amount: (Number(item.totalPayAmount) / 100),
            type: '总金额',
          });
          arr.push({
            periodStr: item.periodStr,
            amount: (Number(item.livePayAmount) / 100),
            type: '直播金额',
          });
          arr.push({
            periodStr: item.periodStr,
            amount: (Number(item.preJobPayAmount) / 100),
            type: '岗前金额',
          });
        });
        this.result.payAmountList = arr;
      }
      // 处理柱状图数据
      if (this.result.agencyTopAmountList.length > 0) {
        this.result.agencyTopAmountList.forEach((item) => {
          item.num /= 100;
        });
      }
    },
    // 切换tabs
    handleClick() {
      this.getHomePageStatistics();
    },
    // initTime
    initTime() {
      // const year = this.$time().year();
      // const month = this.$time().month();
      const day = this.$time();
      this.searchForm.year = `${this.$time()}`;
      this.searchForm.month = `${this.$time()}`;
      console.log(this.searchForm);
      this.searchForm.day = day;
    },
  },
};
</script>
<style lang="scss" scoped>
.statistics{
  padding-top: 10px;
  .statistics-header{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .el-date-editor{
      max-width: 150px;
      margin-left: 20px;
    }
  }
}
</style>
